import { Col, Container, Row } from "reactstrap";
import Chip from "src/components/Common/UI/Chips/Chip";
import UnitConfigurationHeaders from "./UnitConfigurationHeaders";
import Departments from "./Departments/Departments";



const DepartmentConfiguration = () =>{
  
    const chipHeaders = [""];
    const chipItems: React.ReactNode[] = [
      <Departments/>,
      
      
    ];
  
    return (
      <div className="page-content">
        <UnitConfigurationHeaders />
  
        <Container fluid>
          <Row>
            <Col xs={12}>
              {<Chip
                tabNavHeaderItems={chipHeaders}
                tabContentItems={chipItems}
                hasStatusCircle={false}
              />}
            </Col>
          </Row>
        </Container>
  
  
      </div>
    );
}

export default DepartmentConfiguration